import React from 'react';

import { AvGroup } from 'availity-mobx-reactstrap-validation';
import TitleInput from './TitleInput';

export default props => (
  <AvGroup>
    <TitleInput {...props} />
  </AvGroup>
);
